<!--スケジュール-->
<!--tab3勤務実績情報表示-->
<template>
  <div style="border: 0px solid red; height:100%" class="s0001tab3Class">
    <!-- 年月 -->
    <el-row type="flex" align="bottom">
      <el-col :span="9" align="middle">
        <span>{{selectedMonthStr}}</span>
      </el-col>
      <el-col :span="14" align="right" style="font-size: 0">
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="preMonthClick">{{$t('MODULE.S0001_LBL_PREMONTH')}}</el-button>
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="todayClick">{{$t('MODULE.S0001_LBL_TODAY')}}</el-button>
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="nextMonthClick">{{$t('MODULE.S0001_LBL_NEXTMONTH')}}</el-button>
      </el-col>
    </el-row>
    <!-- リスト表示 -->
    <el-row style="margin-top: 6px;">
      <el-col :span="24" align="right">
        <el-radio-group v-model="calenderMode" @change="radioChange">
          <el-radio label="1">{{$t('MODULE.S0001_LBL_RADIO_CALENDER')}}</el-radio>
          <el-radio label="2">{{$t('MODULE.S0001_LBL_RADIO_LIST')}}</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <!----------------------------------------カレンダー表示  calenderMode==1------------------------------>
    <el-row v-show="calenderMode==1" class="calenderMode1-calendar" style="text-align:center;margin-top: 8px;">
      <div style="padding: 0px 0px 0px 0px; width: 100%;height: 100%;">
        <el-calendar :firstDayOfWeek="7" ref="elCalendar">
          <template slot="dateCell" slot-scope="{date, data}">
            <div slot="reference" class="el-calendar-day" @click="dateCellClick(data.day)">
              <div v-html="data.day.split('-')[2]"></div>
              <div v-html="calendarCellcharacters(data)"></div>
            </div>
          </template>
        </el-calendar>
      </div>
      <!--カード-->
      <!-- <div align="left" style="background-color: #23b2e8;">
        <span align="left">・{{toStrToDay2(this.selectedDay)}}</span>
      </div> -->
      <el-card v-show="selectedDay" align="left" shadow="always" style="margin-top: 4px;background-color: #23b2e8;color:#ffffff" :body-style="{ padding:'4px 2px 4px 2px' }">
        <span>・{{toStrToDay2(this.selectedDay)}}</span>
      </el-card>
      <template v-for="(item,index) in clickDayInfo">
        <el-card shadow="always" style="margin-top: 6px;background-color: #f7fbfc;" :body-style="{ padding:'4px 2px 4px 2px' }">
          <table width='100%' border='0' cellspacing='0' cellpadding='0' class="detailTable">
            <tr align="left">
              <td style="width:50%">{{$t('MODULE.S0001_LBL_TAB3_STORE_IN')}}</td>
              <td style="width:50%">{{item.storeIn}}</td>
            </tr>
            <tr align="left">
              <td>{{$t('MODULE.S0001_LBL_TAB3_STORE_OUT')}}</td>
              <td>{{item.storeOut}}</td>
            </tr>
            <tr align="left">
              <td>{{$t('MODULE.S0001_LBL_TAB3_BREAK_TIME')}}</td>
              <td>{{item.breakTime}}</td>
            </tr>
            <tr align="left">
              <td>{{$t('MODULE.S0001_LBL_TAB3_LATENIGHT_BREAK_TIME')}}</td>
              <td>{{item.latenightBreakTime}}</td>
            </tr>
            <tr align="left">
              <td>{{$t('MODULE.S0001_LBL_TAB3_WORK_TIME')}}</td>
              <td>{{item.workTime}}</td>
            </tr>
            <tr align="left">
              <td>{{$t('MODULE.S0001_LBL_TAB3_OVER_TIME')}}</td>
              <td>{{item.overTime}}</td>
            </tr>
            <tr align="left">
              <td>{{$t('MODULE.S0001_LBL_TAB3_HOURLY_WAGE')}}</td>
              <td>{{valueThreeFormart(item.hourlyWage)}}</td>
            </tr>
            <tr align="left">
              <td>{{$t('MODULE.S0001_LBL_TAB3_TRANSPORT_FEE')}}</td>
              <td>{{valueThreeFormart(item.transportFee)}}</td>
            </tr>
          </table>
        </el-card>
      </template>
    </el-row>
    <!--------------------リスト表示 --calenderMode==2------------------------------------------->
    <el-row ref="calenderMode2calendar" v-show="calenderMode==2" class="calenderMode2-calendar" style="text-align:center;margin-top: 8px;">
      <el-table :data="calenderDateList" border stripe style="width: 100%;" @row-click="calender2RowClick" :cell-style="IsCellStyle" :header-row-class-name="HeaderClass" :cell-class-name="IsCellClass">
        <!-- 日付-->
        <el-table-column prop="jobDate" :label="$t('MODULE.S0001_LBL_TAB3_JOBDATE')" width="60" align="center">
          <template slot-scope="scope">
            <span>{{toStrToDay(scope.row.jobDate)}}</span>
          </template>
        </el-table-column>
        <!-- 出勤 退勤-->
        <el-table-column prop="attendanceDiv" :label="$t('MODULE.S0001_LBL_TAB3_STORE_IN_OUT')" width="65">
          <template slot-scope="scope">
            <span>
              <span>{{scope.row.storeIn}}<br />{{scope.row.storeOut}}</span>
            </span>
          </template>
        </el-table-column>
        <!-- 総休憩 深夜休-->
        <el-table-column :label="$t('MODULE.S0001_LBL_TAB3_LATENIGHT_AND_BREAK')" prop="timeLong" width="68">
          <template slot-scope="scope">
            <span>{{scope.row.breakTime}}<br />{{scope.row.latenightBreakTime}}</span>
          </template>
        </el-table-column>
        <!-- 総勤務 残業 -->
        <el-table-column :label="$t('MODULE.S0001_LBL_TAB3_WORK_OVER_TIME')" prop="remark" width="68">
          <template slot-scope="scope">
            <span>{{scope.row.workTime}}<br />{{scope.row.overTime}}</span>
          </template>
        </el-table-column>
        <!-- 時給 交通費 -->
        <el-table-column :label="$t('MODULE.S0001_LBL_TAB3_HOURLY_WAGE_TRANSPORT_FEE')" prop="remark">
          <template slot-scope="scope">
            <span>{{valueThreeFormart(scope.row.hourlyWage)}}<br />{{valueThreeFormart(scope.row.transportFee)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!---------------------詳細情報dialog--------------------------------------------------------------->
    <el-dialog title="詳細情報" :visible.sync="detailDialogVisible" width="90%" :append-to-body="true" class="s0001tab3Dialog">

      <table width='100%' border='0' cellspacing='0' cellpadding='0' class="cal2DetailTable">
        <template v-for="(item,index) in detailList">
          <tr align="left">
            <td style="width:70%">{{item.itemName}}</td>
            <td style="width:30%">{{itemValueFormart(item)}}</td>
          </tr>
        </template>
      </table>
    </el-dialog>
  </div>
</template>
<script>
import * as amsApi from "../api/s_0001"
import locale from "element-ui/lib/locale/lang/ja"
let url = require('@/../config/sysConfig')
import utilsApi from '../../common/utils'
export default {
  // name: "Map",
  data() {
    return {
      tabsIndex: '',
      calenderDateList: [],//calender1表示用list
      selectedMonth: '',//当前月（字符串格式）
      selectedDay: '',//当前点击的日期（字符串格式）
      calenderMode: '1',//1：calender表示，2：list表示
      login_officeCd: '',//登陆者所属officecd
      login_userCd: '',//登陆者cd
      icon_o: '〇',
      icon_v: '✔',
      weekStr: [],//一周的文言
      clickDayInfo: [],//点击一天的详细list
      detailDialogVisible: false,//详细dialog表示flg
      detailList: [],//详细dialog表示的list
    };
  },

  mounted() {
    //カレンダーのセルセット
    let calendarThead = document.querySelector(
      ".s0001tab3Class .el-calendar-table thead"
    );
    calendarThead.childNodes[0].style.color = "red"
    calendarThead.childNodes[6].style.color = "blue"
    this.weekStr[0] = this.$t('MODULE.S0001_LBL_CALENDAR_SUN')
    this.weekStr[1] = this.$t('MODULE.S0001_LBL_CALENDAR_MON')
    this.weekStr[2] = this.$t('MODULE.S0001_LBL_CALENDAR_TUE')
    this.weekStr[3] = this.$t('MODULE.S0001_LBL_CALENDAR_WED')
    this.weekStr[4] = this.$t('MODULE.S0001_LBL_CALENDAR_THU')
    this.weekStr[5] = this.$t('MODULE.S0001_LBL_CALENDAR_FRI')
    this.weekStr[6] = this.$t('MODULE.S0001_LBL_CALENDAR_SAT')

    for (var i = 0; i < 7; i++) {
      calendarThead.childNodes[i].innerHTML = this.weekStr[i]
    }

    let calendarTbody = document.querySelector(
      ".s0001tab3Class .el-calendar-table tbody"
    );
    var calendarTbodyChildren = calendarTbody.children;
    var calendarTbodyChildrenChildren;
    for (var i = 0; i < calendarTbodyChildren.length; i++) {
      calendarTbodyChildrenChildren = calendarTbody.children[i]
      if (i % 2 != 0) {
        calendarTbodyChildrenChildren.style.background = "#f7fbfc"
      }
    }
  },
  created: function () {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.login_officeCd = userInfo.officeCd
    this.login_userCd = userInfo.userCd
    this.selectedMonth = this.dateFormart(new Date(), 'yyyymm')
    this.query()
  },
  methods: {
    //获得tabsindex
    getTabsIndex(val) {
      this.tabsIndex = val
    },
    //cal2 行点击事件
    calender2RowClick(row) {
      this.detailDialogVisible = true
      var Params = {
        "recNo": row.recNo,
        "month": this.selectedMonth,
        "jobDate": row.jobDate,
        "page": 1,
        "size": 100
      }
      // 検索処理
      amsApi.s0001Tab3_detail_search(Params).then(res => {
        // 初始化前清空
        this.detailList = undefined;
        this.detailList = new Array();
        // this.selectedDay = ''
        // this.clickDayInfo = undefined;
        if (res.code === 300) {
          //  this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          // loading.close()
          return
        } else {

          //更新基本list
          this.detailList = JSON.parse(JSON.stringify(res.items.attendanceDetailSet));

        }
        // loading.close()
      })
    },
    //calender模式切换事件
    radioChange(val) {
      this.selectedDay = ''
      this.clickDayInfo = undefined;
    },

    //日期字符串转化为 日（星期）
    toStrToDay(thisDay) {
      var theDate = new Date(thisDay)
      var myddy = theDate.getDay()
      return thisDay.substring(8, 10) + '(' + this.weekStr[myddy] + ')'

    },
    //日期字符串转化为 年月日（星期）
    toStrToDay2(thisDay) {
      var theDate = new Date(thisDay)
      var myddy = theDate.getDay()
      return thisDay + '(' + this.weekStr[myddy] + ')'

    },
    // 検索
    query() {
      var Params = {
        "month": this.selectedMonth,
        "page": 1,
        "size": 100
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
      // 検索処理
      amsApi.s0001Tab3_search(Params).then(res => {
        // 初始化前清空
        this.calenderDateList = undefined;
        this.calenderDateList = new Array();
        this.selectedDay = ''
        this.clickDayInfo = undefined;
        if (res.code === 300) {
          //  this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          loading.close()
          return
        } else {
          //更新基本list
          this.calenderDateList = JSON.parse(JSON.stringify(res.items.attendanceSet));
        }
        loading.close()
      })
    },
    //日期转为字符串formartType='yyyymm'或'yyyymmdd'，
    dateFormart(val, formartType) {
      var y = val.getFullYear();
      var M = val.getMonth() + 1;
      var d = val.getDate();
      if (formartType == 'yyyy-mm-dd') return y + '-' + (M < 10 ? ('0' + M) : M) + '-' + (d < 10 ? ('0' + d) : d);
      if (formartType == 'yyyy/mm/dd') return y + '/' + (M < 10 ? ('0' + M) : M) + '/' + (d < 10 ? ('0' + d) : d);
      if (formartType == 'yyyymm') return y + '' + (M < 10 ? ('0' + M) : M);

    },
    //详细情报格式化
    itemValueFormart(item) {
      var ret;
      if (item.itemValue === null || item.itemValue === '') {
        ret = '0'
      } else {
        if (item.itemStyle === 'money') {
          //数字格式化为三位一个逗号
          ret = this.valueThreeFormart(item.itemValue)
        }else if(item.itemStyle === 'minute'){ 
          //分钟转时刻
          ret =this.minutesIntoTime(parseInt(item.itemValue))  
        }else {
          ret = item.itemValue
        }
      }
      return ret
    },
    // 分钟转换成時刻
    minutesIntoTime(minutes) {
      var h = Math.floor(minutes / 60) < 10 ? '0' + Math.floor(minutes / 60) : Math.floor(minutes / 60)
      var m = minutes % 60 < 10 ? '0' + minutes % 60 : minutes % 60
      return h + ':' + m
    },
    //数字格式化为三位一个逗号
    valueThreeFormart(value) {
      if (value === '' || value === null) return ''
      var s = value;
      s = parseFloat(value).toLocaleString()
      return s
    },
    //前月翌月今日综合处理
    monthChange(val) {
      var getEl = this.$refs.elCalendar.$children[0].$children[val]
      //触发调转事件
      getEl.$el.click();
      this.$nextTick(() => {
        let calendarTitle = document.querySelector(
          ".s0001tab3Class .el-calendar__header .el-calendar__title"
        );
        var monthStr = calendarTitle.innerHTML
        if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
          this.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16)
        } else {
          this.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15)
        }
        //刷新数据
        this.query()
        if (document.querySelector(".is-selected") !== null) {
          document.querySelector(".is-selected").classList.remove('is-selected');
        }

      })
    },
    //前月
    preMonthClick() {
      this.monthChange(0)
    },
    //今日
    todayClick() {
      this.monthChange(1)
    },
    //翌月
    nextMonthClick() {
      this.monthChange(2)
    },

    //日期单元格点击事件。  参数空的场合，直接使用this.selectedDay
    dateCellClick(in_dateDay) {
      if (in_dateDay !== '') {
        this.selectedDay = in_dateDay.replace(/-/g, '/')
      }
      this.clickDayInfo = undefined;
      this.clickDayInfo = new Array();
      for (var i = 0; i < this.calenderDateList.length; i++) {
        var item = this.calenderDateList[i]
        if (item.jobDate === this.selectedDay) {
          this.clickDayInfo.push(item)
        }
      }
    },
    //单元格内容表示
    calendarCellcharacters(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/')
      var ret = ''
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(item => item.jobDate === thisDay)
      if (Index !== -1) {
        ret = this.icon_o
      } else {
        ret = ''
      }
      return ret
    },
    //cal2的cell样式
    HeaderClass({ row, rowIndex }) {
      return 'HeaderClass'
    },
    //cal2的head样式
    IsCellStyle({ row, colum, rowIndex, columnIndex }) {
      return 'text-align:center;'
    },
    //cal2的head样式
    IsCellClass({ row, rowIndex }) {
      return 'IsCellClass'
    },
  },
  computed: {
    //selectedMonth->selectedMonthStr yyyymm->yyyy年mm月
    selectedMonthStr() {
      return this.selectedMonth.substring(0, 4) + '年' + this.selectedMonth.substring(4, 7) + '月'
    }
  },
};
</script>
<style>
.s0001tab3Class * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.s0001tab3Class .is-selected {
  color: #000000;
  font-weight: bold;
}
.s0001tab3Class .el-calendar-table .el-calendar-day {
  height: 50px;
  padding: 0px;
}
.s0001tab3Class .el-calendar__body {
  padding-bottom: 10px;
  padding: 0 0 0 0;
}
/* 本月以外の日付はクリック無効 */
.s0001tab3Class .el-calendar-table td.next {
  pointer-events: none;
}
.s0001tab3Class .el-calendar-table td.prev {
  pointer-events: none;
}
/* copy paste 禁止 */
.s0001tab3Class .calenderMode1-calendar * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.s0001tab3Class .el-main {
  height: 100%;
  padding: 0 !important;
  overflow: hidden;
  position: relative;
}

.s0001tab3Class .el-calendar-table thead th {
  background-color: #3f50ec27;
  border: 1px solid #e2e3e4;
  padding-top: 7px;
  padding-bottom: 7px;
}
/*input输入框*/
.s0001tab3Class .card-css-input {
  width: 100%;
  padding: 0px 0px 0px 0px;
}
/* 隐藏calendar的日期头和按钮部分 */
.s0001tab3Class .el-calendar .el-calendar__header {
  display: none;
}
/* radio间距 */
.s0001tab3Class .el-radio {
  margin-right: 5px;
}
.s0001tab3Class .calenderMode2-calendar .cell {
  padding-left: 4px;
  padding-right: 4px;
}
.s0001tab3Class .calenderMode2-calendar .el-input__inner {
  padding-left: 7px;
  padding-right: 4px;
}
.s0001tab3Class .calenderMode2-calendar .el-table td,
.el-table th {
  text-align: center;
}

.s0001tab3Class .opacity {
  position: absolute;
  width: 100px;
  -khtml-opacity: 0.2;
  -moz-opacity: 0.2;
  filter: alpha(opacity=20);
  filter: 'alpha(opacity=20)';
  opacity: 0.2;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=20);
  z-index: 200; /*兼容ie8及以下*/
}

/* 使用换行符可以换行 */
/* .s0001tab3Class .el-table .cell {
  white-space: pre-line;
} */
/* 文字溢出省略号 */
/* .s0001tab3Class .el-table .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
} */
.s0001tab3Class .HeaderClass .cell {
  white-space: pre-line;
}
.s0001tab3Class .IsCellClass .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.s0001tab3Class table.detailTable {
  width: 100%;
  border: 2px solid #444;
  border-spacing: 0;
}
.s0001tab3Class table.detailTable tr,
.s0001tab3Class table.detailTable th {
  border-bottom: 1px solid #444;
}
.s0001tab3Class table.detailTable td,
.s0001tab3Class table.detailTable th {
  border-right: 1px solid #444;
  border-bottom: 1px solid #444;
  padding: 5px;
}
.s0001tab3Class table.detailTable tr td:last-child {
  border-right: 0;
}
.s0001tab3Class table.detailTable tr:last-child td {
  border-bottom: 0;
}
.s0001tab3Class .el-table th {
  background-color: #23b2e8;
  color: #ffffff;
}
.s0001tab3Dialog table.cal2DetailTable {
  width: 100%;
  border: 2px solid #444;
  border-spacing: 0;
}
.s0001tab3Dialog table.cal2DetailTable tr,
.s0001tab3Dialog table.cal2DetailTable th {
  border-bottom: 1px solid #444;
}
.s0001tab3Dialog table.cal2DetailTable td,
.s0001tab3Dialog table.cal2DetailTable th {
  border-right: 1px solid #444;
  border-bottom: 1px solid #444;
  padding: 5px;
}
.s0001tab3Dialog table.cal2DetailTable tr td:last-child {
  border-right: 0;
}
.s0001tab3Dialog table.cal2DetailTable tr:last-child td {
  border-bottom: 0;
}
.s0001tab3Dialog .el-dialog__body {
  /* border-top: 0px solid #dcdfe6; */
  /*border-bottom: 1px solid #dcdfe6; */
  max-height: 400px !important;
  min-height: 100px;
  overflow-y: auto;
}
.s0001tab3Dialog .el-dialog__header {
  /* border-top: 0px solid #dcdfe6; */
  /*border-bottom: 1px solid #dcdfe6; */
  background-color: #23b2e8;
  padding: 10px 0px 6px 10px;
}
.s0001tab3Dialog .el-dialog__headerbtn {
  top: 10px;
}
.s0001tab3Dialog .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}
/* 奇数行变色 */
.s0001tab3Dialog table.cal2DetailTable tr:nth-child(even) {
  background: #f7fbfc;
}

.s0001tab3Dialog .el-dialog__title {
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/module/page/s_0001_tab3.vue